import { Action, createReducer, on } from '@ngrx/store';
import { MetricListResponse, ModelMetricListResponse } from '../../../api/models';
import { ILoaderActionPayload, LoadingState } from '../models/loader.model';
import { metricActions } from './metric.actions';

export interface MetricState {
  loadMany: {
    state: ILoaderActionPayload;
    data?: MetricListResponse;
  };
  loadModelMetric: {
    state: ILoaderActionPayload;
    data?: ModelMetricListResponse;
  };
}

const initialState: MetricState = {
  loadMany: { state: { value: LoadingState.NONE } },
  loadModelMetric: { state: { value: LoadingState.NONE } },
};

const reducer = createReducer(
  initialState,
  on(metricActions.loadMany, (state) => ({
    ...state,
    loadMany: { state: { value: LoadingState.LOADING } },
  })),
  on(metricActions.loadManyDone, (state, props) => ({
    ...state,
    loadMany: { state: props.state, data: props.data },
  })),
  on(metricActions.loadModelMetric, (state) => ({
    ...state,
    loadModelMetric: { state: { value: LoadingState.LOADING } },
  })),
  on(metricActions.loadModelMetricDone, (state, props) => ({
    ...state,
    loadModelMetric: { state: props.state, data: props.data },
  })),
);

export function metricReducer(state: MetricState | undefined, action: Action) {
  return reducer(state, action);
}
